// removed by extract-text-webpack-plugin
module.exports = {"container":"F40C2JxQUY-OMYqcK7DGb","tag":"_1Jt3cbhNoBNWxvXmZwrYad","tagText":"_3qHBRrPYO8spI9LyIw8neZ","deleteTag":"_3LyzynYupCm9l5MK2-HzXp","input":"_2p2rerjLMiLS-4GRJswZ5v"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/fields/TagsFilter/styles.css
// module id = 2711
// module chunks = 0